import { dynamicLoadPhoneNumberInput } from "./dynamic-load-phone-number-input.js";
const getParsePhoneNumber = async () => {
  const { parsePhoneNumber } = await dynamicLoadPhoneNumberInput();
  return parsePhoneNumber;
};
export {
  getParsePhoneNumber
};
//# sourceMappingURL=get-parse-phone-number.js.map
